import { render, staticRenderFns } from "./address-input.vue?vue&type=template&id=ccb6c734"
import script from "./address-input.vue?vue&type=script&lang=js"
export * from "./address-input.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports